const popupReducer = (state = false, action) => {
    switch (action.type) {
      case 'TOGGLE_POPUP1':
        return !state;
      case 'SET_POPUP1':
        return action.payload;
      default:
        return state;
    }
  };
  
  export default popupReducer;